import './device-list-managed/device-list-managed.component';

function DevicesListingCtrl($stateParams,
                            $q,
                            debounce,
                            $log,
                            DevicesService,
                            $state,
                            SessionsService,
                            ProgressBarService,
                            sweet) {
  "ngInject";
  let vm = this;
  vm.managingOrgId = undefined;
  ////////////////////////////////////////////////////////////////////////////
  // Managed
  ////////////////////////////////////////////////////////////////////////////
  vm.devices = [];
  vm.devicesPrev = null;
  vm.devicesNext = null;
  vm.selectedButton = "Serial Number";
  vm.serialDevices = {};
  vm.idDevices = {};
  vm.disabled = true;
  vm.macDevices = {};
  vm.gcmidDevices = {};
  vm.throttledSearch = null;

  ////////////////////////////////////////////////////////////////////////////
  // Unmanaged
  ////////////////////////////////////////////////////////////////////////////
  vm.unmanagedSelectedButton = "Serial Number";
  vm.unmanagedSerialDevices = {};
  vm.unmanagedIdDevices = {};
  vm.unmanagedDisabled = true;
  vm.unmanagedDevicesPrev = null;
  vm.unmanagedDevicesNext = null;
  vm.unmanagedDevices = [];
  vm.unmanagedMacDevices = {};
  vm.unmanagedGCMidDevices = {};
  vm.devicesToMatchOnUnmanaged = [];
  vm.devicesToMatchOnManaged = [];

  ////////////////////////////////////////////////////////////////////////////

  vm.refreshManagedDevices = function () {
    vm.devicesPrev = null;
    vm.devicesNext = null;
    return vm.getManagedDevices(vm.managingOrgId);
  };

  vm.refreshUnmanagedDevices = function () {
    vm.unmanagedDevicesPrev = null;
    vm.unmanagedDevicesNext = null;
    return vm.getUnmanagedDevices(vm.managingOrgId);
  };

  vm.changeRadio = function (unmanaged) {
    if (unmanaged) {
      vm.unmanagedSearchText = '';
      vm.unmanagedDisabled = true;
      vm.unmanagedSerialDevices = {};
      vm.unmanagedIdDevices = {};
      vm.unmanagedMacDevices = {};
      vm.devicesToMatchOnUnmanaged = [];
    } else {
      vm.searchText = '';
      vm.disabled = true;
      vm.serialDevices = {};
      vm.idDevices = {};
      vm.macDevices = {};
      vm.devicesToMatchOnManaged = [];
    }
  };

  vm.editItem = (item) => {
    DevicesService.editItem(item, false);
  };

  vm.prepareForEditView = function (unmanaged, searchText) {
    let mac, serial, deviceid, gcmid;
    if (unmanaged) {
      mac = vm.unmanagedSelectedButton === "MAC";
      serial = vm.unmanagedSelectedButton === "Serial Number";
      deviceid = vm.unmanagedSelectedButton === "Device Key";
      gcmid = vm.unmanagedSelectedButton === "GCM ID";
      if (mac) {
        return vm.editItem(vm.unmanagedMacDevices[searchText]);
      } else if (serial) {
        return vm.editItem(vm.unmanagedSerialDevices[searchText]);
      } else if (deviceid) {
        return vm.editItem(vm.unmanagedIdDevices[searchText]);
      } else {
        return vm.editItem(vm.unmanagedGCMidDevices[searchText])
      }

    } else {
      mac = vm.selectedButton === "MAC";
      serial = vm.selectedButton === "Serial Number";
      deviceid = vm.selectedButton === "Device Key";
      gcmid = vm.selectedButton === "GCM ID"
      if (mac) {
        return vm.editItem(vm.macDevices[searchText]);
      } else if (serial) {
        return vm.editItem(vm.serialDevices[searchText]);
      } else if (deviceid) {
        return vm.editItem(vm.idDevices[searchText]);
      } else {
        return vm.editItem(vm.gcmidDevices[searchText])
      }
    }
  };

  vm.controlOpenButton = function (unmanaged, isMatch) {
    if (!unmanaged) {
      vm.disabled = !isMatch;
      vm.disabledButtonLoading = false;
    } else {
      vm.unmanagedDisabled = !isMatch;
      vm.unmanagedDisabledButtonLoading = false;
    }
  };

  vm.isResourceValid = function (unmanaged, resource) {
    let devicesToMatchOn = unmanaged ? vm.devicesToMatchOnUnmanaged : vm.devicesToMatchOnManaged
    let foundMatch = false;
    for (let item of devicesToMatchOn) {
      if (resource === item) {
        foundMatch = true;
      }
    }
    vm.controlOpenButton(unmanaged, foundMatch)
    return foundMatch
  };

  vm.searchDevices = function (unmanaged, partial) {
    let deferred = $q.defer()
    let button;
    if (unmanaged) {
      button = vm.unmanagedSelectedButton;
    } else {
      button = vm.selectedButton;
    }

    let byTenant = false;
    let tenantId = null;

    if (vm.throttledSearch) {
      vm.throttledSearch.cancel();
    }

    vm.throttledSearch = debounce(250, function () {
      DevicesService.searchDevices(partial, button, byTenant, tenantId, vm.managingOrgId, unmanaged)
        .then(function (response) {
          // the 0 index is the list of devices as string
          // the 1 index is objects with name as key, values as well, value
          let devicesToReturn;
          if (response.success) {
            let devices = response.devices;
            if (button === "Serial Number") {
              if (unmanaged) {
                vm.unmanagedSerialDevices = devices[1]
              } else {
                vm.serialDevices = devices[1]
              }
              devicesToReturn = devices[0]
            } else if (button === "Device Key") {
              if (unmanaged) {
                vm.unmanagedIdDevices = devices[1]
              } else {
                vm.idDevices = devices[1]
              }
              devicesToReturn = devices[0]
            } else if (button === "MAC") {
              if (unmanaged) {
                vm.unmanagedMacDevices = devices[1]
              } else {
                vm.macDevices = devices[1]
              }
              devicesToReturn = devices[0]
            } else {
              if (unmanaged) {
                vm.unmanagedGCMidDevices = devices[1]
              } else {
                vm.gcmidDevices = devices[1]
              }
              devicesToReturn = devices[0]
            }
            if (unmanaged) {
              vm.devicesToMatchOnUnmanaged = devicesToReturn
            } else {
              vm.devicesToMatchOnManaged = devicesToReturn
            }
            deferred.resolve(devicesToReturn)
          } else {
            deferred.resolve([])
          }
        })
    });

    vm.throttledSearch();
    return deferred.promise
  };

  vm.getManagedDevices = function (key, page) {
    vm.loadingDevices = true;
    ProgressBarService.start();
    let devicesPromise = DevicesService.getDevicesByManagingOrg(key, page);
    return devicesPromise.then((function (response) {
      vm.loadingDevices = false;
      vm.devices = response.devices;
      vm.devicesNext = response.next;
      vm.devicesPrev = response.previous;
      return vm.getFetchSuccess();
    }), response => vm.getFetchFailure(response));
  };

  vm.getUnmanagedDevices = function (key, page) {
    ProgressBarService.start();
    vm.loadingDevices = true;
    let unmanagedDevicesPromise = DevicesService.getUnmanagedDevicesByDistributor(key, page);
    return unmanagedDevicesPromise.then((function (response) {
      vm.loadingDevices = false;
      vm.unmanagedDevices = response.devices;
      vm.unmanagedDevicesPrev = response.previous;
      vm.unmanagedDevicesNext = response.next;
      return vm.getFetchSuccess();
    }), response => vm.getFetchFailure(response));
  };

  vm.initialize = function () {
    vm.managingOrgId = SessionsService.getCurrentDistributorKey();
    vm.getManagedDevices(vm.managingOrgId);
    return vm.getUnmanagedDevices(vm.managingOrgId, vm.unmanagedDevicesPrev, vm.unmanagedDevicesNext);
  };

  vm.getFetchSuccess = () => ProgressBarService.complete();

  vm.getFetchFailure = function (response) {
    ProgressBarService.complete();
    let errorMessage = `Unable to fetch devices. Error: ${response.status} ${response.statusText}.`;
    return sweet.show('Oops...', errorMessage, 'error');
  };


  vm.paginateCall = function (forward, managed) {
    if (forward) {
      if (managed) {
        vm.getManagedDevices(vm.managingOrgId, vm.devicesNext);
      }
      if (!managed) {
        vm.getUnmanagedDevices(vm.managingOrgId, vm.unmanagedDevicesNext);
      }
    } else {
      if (managed) {
        vm.getManagedDevices(vm.managingOrgId, vm.devicesPrev);
      }
      if (!managed) {
        return vm.getUnmanagedDevices(vm.managingOrgId, vm.unmanagedDevicesPrev);
      }
    }
  };

  return vm;
}
export {DevicesListingCtrl}

